import { newPassword } from '@pulsepoint/shared';
import { z } from 'zod';

const sameAs = (a: string, b: string) => a === b;

/** Choose a password, twice. */
export const choosePassword = z
  .object({ password: newPassword, confirm: z.string() })
  .refine((v) => sameAs(v.password, v.confirm), { path: ['confirm'], message: "The two passwords don't match" });

export const changePassword = z
  .object({ currentPassword: z.string().min(1, 'Enter your current password'), newPassword, confirm: z.string() })
  .refine((v) => sameAs(v.newPassword, v.confirm), { path: ['confirm'], message: "The two passwords don't match" })
  .refine((v) => v.newPassword !== v.currentPassword, { path: ['newPassword'], message: 'Choose a different password from your current one' });
